import { Component, inject, OnInit, OnDestroy, Input, Inject, ViewChild } from '@angular/core';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, UrlSegment } from '@angular/router';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionModule } from '@angular/material/expansion'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatMenuModule } from '@angular/material/menu'
import { MatInputModule } from '@angular/material/input'
import { MatFormField } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider'
import { MatChipsModule } from '@angular/material/chips'
import { AsyncPipe, CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { BehaviorSubject, catchError, firstValueFrom, forkJoin, from, map, Observable, of, Subscription, switchMap, tap, combineLatest, take } from 'rxjs';
import { AgePipe } from '../age.pipe';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EncounterServiceService } from '../patient-wrapper/encounter-service.service';
import { Bundle, BundleEntry, ChargeItem, Invoice, Organization, Patient, Practitioner, ServiceRequest } from 'fhir/r4';
import { References2Pipe } from "../shared/references2.pipe";
import { fetchFromReferencePipe } from "../shared/Fetch.pipe";
import { LinkInReferencesService } from '../shared/link-in-references.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DetailBaseComponent } from '../shared/detail-base/detail-base.component';
import { CodeableRef2Pipe } from "../shared/codeable-ref2.pipe";
import { CodeableConcept2Pipe } from "../shared/codeable-concept2.pipe";
import { AuthService, capacityObject } from '../shared/auth/auth.service';
import { UtilityService } from '../shared/utility.service';
import { SpecimenComponent } from '../specimen/specimen_old.component';
import { SpecimenDetailsComponent } from '../specimen/specimen-details/specimen-details.component';
import { LabrequestDetailsComponent } from '../labrequest-details/labrequest-details.component';
import { LabreportComponent } from '../labreport/labreport.component';
import { AddReportComponent } from '../labreport/add-report/add-report.component';
import { AddObservationComponent } from '../patient-observation/add-observation/add-observation.component';
import { StateService } from '../shared/state.service';
import { ErrorService } from '../shared/error.service';
import { Resource } from 'fhir/r4';
import { ChipsDirective } from "../chips.directive";
import { ReferenceDisplayDirective } from '../shared/reference-display.directive';
import { NaPipe } from "../shared/na.pipe";
import { EmptyStateComponent } from "../shared/empty-state/empty-state.component";
import { DetailsBuilderObject } from '../detailz-viewz/details-builder.service';
import { DetailzViewzComponent, DetailActionButton } from '../detailz-viewz/detailz-viewz.component';
import { AddSpecimenComponent } from '../specimen/add-specimen/add-specimen.component';
import { SpecimenSelectionComponent } from '../labreport/specimen-selection/specimen-selection.component';
import { FhirResourceTransformService } from '../shared/fhir-resource-transform.service';
import { FhirResourceService } from '../shared/fhir-resource.service';
import { SuccessMessageComponent } from '../shared/success-message/success-message.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { backendEndPointToken, terminologyCanonicalUrlBaseToken } from '../app.config';
import { Observation } from 'fhir/r4';
import { referenceArrayContains, referenceMatches } from '../shared/fhir-reference.util';
import { RequestPrintService } from '../shared/request-print.service';
import { InfoDialogService } from '../shared/info-dialog/info-dialog.service';
import { ServiceRequestsService } from '../service-requests/service-requests.service';
import { ServiceRequestSearchService } from '../service-requests/service-request-search.service';
import { LabBillingPlaceholderService } from '../shared/services/lab-billing-placeholder.service';
import { ItemsRequiredEditorComponent } from '../shared/items-required-editor/items-required-editor.component';
import { EmphasisDirective } from '../shared/directives/emphasis.directive';
import { ObservationSelectorDialogComponent } from './observation-selector-dialog/observation-selector-dialog.component';
import { RequiredObservationResultsTableComponent } from '../shared/required-observation-results-table/required-observation-results-table.component';
import { ResourceStatusChangesService } from '../resource-status-changes/resource-status-changes.service';
import { ConfirmDialogComponent } from '../shared/confirm-dialog/confirm-dialog.component';
import { Subject } from 'rxjs';
import { takeUntil, debounceTime, shareReplay, distinctUntilChanged } from 'rxjs/operators';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ResourceRefreshService } from '../shared/resource-refresh.service';

@Component({
  selector: 'app-lab-requests',
  imports: [MatCardModule, MatButtonModule, MatProgressSpinnerModule, DetailBaseComponent,
    MatFormField, MatDividerModule, DatePipe, RouterLink,
    RouterLinkActive, CommonModule, ReferenceDisplayDirective,
    MatExpansionModule, MatCheckboxModule, TitleCasePipe,
    MatTableModule, AsyncPipe,
    MatChipsModule, MatMenuModule,
    MatInputModule, MatFormFieldModule, EmphasisDirective,
    MatInputModule,
    ReactiveFormsModule, MatSelectModule,
    MatMenuModule, AgePipe, TableHeaderComponent,
    MatMenuModule, AgePipe, TableHeaderComponent, MatPaginatorModule,
    MatTableModule, MatIconModule, ReactiveFormsModule, References2Pipe, fetchFromReferencePipe, CodeableRef2Pipe, CodeableConcept2Pipe, ChipsDirective, NaPipe, EmptyStateComponent, MatSortModule],
  templateUrl: './lab-requests.component.html',
  styleUrls: ['../medicine-requests/medicine-requests.component.scss', './lab-requests.component.scss']
})
export class LabRequestsComponent implements OnInit, OnDestroy {
  auth = inject(AuthService);
  private readonly billingPlaceholder = inject(LabBillingPlaceholderService);
  labRequestsData: any;
  canOrderTests$: Observable<boolean> = new BehaviorSubject<boolean>(false);

  private readonly destroy$ = new Subject<void>();
  labRequests?: ServiceRequest[]
  sortedWithRequisition: { [key: string]: ServiceRequest[] } = {};
  sortedWithRequisitionKeys: string[] = [];
  tableDataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort!: MatSort;
  tableDataLevel2: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([])
  references: Map<string, any> = new Map();
  @Input() forCheckSheet?: boolean
  @Input() labRequestTableColumns?: string[];

  // status  - https://hapi.fhir.org/baseR4/ValueSet/$expand?url=http://hl7.org/fhir/ValueSet/request-status&_format=json

  // intent - https://hapi.fhir.org/baseR4/ValueSet/$expand?url=http://hl7.org/fhir/ValueSet/request-intent&_format=json

  // priority - https://hapi.fhir.org/baseR4/ValueSet/$expand?url=http://hl7.org/fhir/ValueSet/request-priority&_format=json

  // code  - filter - http://tx.fhir.org/r4/ValueSet/$expand?url=http://hl7.org/fhir/ValueSet/procedure-code&_FORMAT=JSON&filter=blood%20sugar

  // orderDetail.parameter.code - (form your own)

  // orderDetail.parameter.valueString - textarea

  // subject

  // authoredOn

  // requester

  //performer-type - http://tx.fhir.org/r4/ValueSet/$expand?url=http://hl7.org/fhir/ValueSet/participant-role&_FORMAT=JSON



  searchControl = new FormControl('');
  chargeItemsReserve: ChargeItem[] = [];
  invoicesReserve: Invoice[] = [];
  // patientName!: Observable<string>;
  // patientId!: string;
  private readonly baseDisplayedColumns = [
    'requisition',
    'authoredOn',
    'status',
    'priority',
    'code',
    'action',
    'groupReport'
  ];
  labRequestsDisplayedColumns = [...this.baseDisplayedColumns];
  @Input() set labRequestTableFilters(filters: Array<{ field: string; values?: any[] }> | undefined) {
    this.appliedExternalFilters = (filters || []).filter(Boolean);
    this.applyAllFilters();
  }
  http = inject(HttpClient);
  route = inject(ActivatedRoute);
  encounterService = inject(EncounterServiceService);
  sRServ = inject(ServiceRequestsService);
  private statusChanges = inject(ResourceStatusChangesService);
  private resourceRefresh = inject(ResourceRefreshService);

  referenceObject: any = {}

  constructor(private router: Router) {
  }
  userRole = this.auth.user?.getValue()?.role || 'non_user';
  utilityService = inject(UtilityService);
  capacityObject = capacityObject;
  user: any = null;
  patientId: string | null = null;
  patientname: string | null = null;
  // Initialize permission observables with false
  canAddRequests$: Observable<boolean> = new BehaviorSubject<boolean>(false);
  canExportRequests$: Observable<boolean> = new BehaviorSubject<boolean>(false);

  stateService = inject(StateService);
  errorService = inject(ErrorService);
  state = inject(StateService);
  private useOrgWideServiceRequests = false;
  private appliedExternalFilters: Array<{ field: string; values?: any[] }> = [];

  private appliedLabRequestFilters: Array<{ field: string; values?: any[] }> = [];
  private rawLabRequests: any[] = [];
  private serviceRequestIdFromRoute: string | null = null;
  private autoDialogOpened = false;
  priorityFilterControl = new FormControl<string[]>([]);
  statusFilterControl = new FormControl<string[]>([]);

  pageSize = 25;
  paginatorPageIndex = 0;
  srSearch = inject(ServiceRequestSearchService);
  loading$ = this.srSearch?.loading$;
  total$ = this.srSearch?.total$;
  error$ = this.srSearch?.error$;

  searchableFields = [
    { label: 'Patient ID', value: 'subject:Patient.identifier' },
    // { label: 'Requisition ID', value: 'requisition' },
    { label: 'Service Name', value: 'code:text' }
  ];
  selectedSearchField = 'subject:Patient.identifier';

  priorityOptions = ['ASAP', 'Urgent', 'Routine'];
  statusOptions = ['active', 'completed', 'cancelled', 'entered-in-error', 'unknown'];

  private readonly terminologyBaseUrl = inject(terminologyCanonicalUrlBaseToken);
  private readonly organizationTenantTagSystem = `${this.terminologyBaseUrl}/CodeSystem/organizationTenant`;
  private readonly organizationTenantExtensionUrl = `${this.terminologyBaseUrl}/StructureDefinition/organizationTenant`;
  private readonly legacyHospitalExtensionUrl = 'hospitalId';
  private readonly actorOrganizationExtensionUrl = 'http://e-likita.org/fhir/StructureDefinition/actor-organization';

  private readonly availabilitySets$ = this.utilityService.getAllServiceRequestCodesFromCodeSystem().pipe(
    map((options: any[]) => {
      const pairSet = new Set<string>();
      const codeSet = new Set<string>();
      const displaySet = new Set<string>();
      for (const opt of (options || [])) {
        if (!opt?.active) continue;
        const code = (opt?.code || '').toString().trim().toLowerCase();
        if (!code) continue;
        codeSet.add(code);
        const system = (opt?.system || '').toString().trim().toLowerCase();
        if (system) pairSet.add(`${system}::${code}`);
        const display = (opt?.display || '').toString().trim().toLowerCase();
        if (display) displaySet.add(display);
      }
      return { pairSet, codeSet, displaySet };
    }),
    shareReplay(1),
    catchError(() => of({ pairSet: new Set<string>(), codeSet: new Set<string>(), displaySet: new Set<string>() }))
  );


  async ngOnInit() {
    // Compute permissions for 'labRequest' resource
    this.computePermissions('labRequest');

    this.route.queryParamMap
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        const id = params.get('serviceRequestId');
        this.serviceRequestIdFromRoute = id;
        if (!id) {
          this.autoDialogOpened = false;
        }
        this.autoOpenDialogFromRoute();
      });

    this.canOrderTests$ = this.auth.user.pipe(
      map(() => this.auth.canOrderTests())
    );

    this.auth.user.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      this.user = user;

      if (this.route.parent?.routeConfig?.path?.includes('testing')) {
        this.encounterService.setEncounterState('100001', 'in-progress');
        this.user = { role: 'testing' };
        this.patientId = '100001';
        capacityObject['labRequest']['request'].push('testing');
      }
    });

    // Determine patient context
    const resolvedPatientId = this.stateService.currentPatientIdFromResolver.getValue();
    const encounterPatientId = this.stateService.currentEncounter.getValue()?.patientId ?? null;
    const canViewAllLabRequests = this.auth.can('labRequest', 'viewAll');

    if (!resolvedPatientId && !encounterPatientId) {
      // if (!canViewAllLabRequests) {
      //   this.errorService.openandCloseError("No patient selected. Please select a patient to view lab requests.");
      //   this.router.navigate(['/app/patients']);
      //   return;
      // }
      this.useOrgWideServiceRequests = true;
      this.patientId = null;
      // Add subject column for org-wide view
      if (!this.baseDisplayedColumns.includes('subject')) {
        this.baseDisplayedColumns.splice(5, 0, 'subject');
      }
      this.labRequestsDisplayedColumns = [...this.baseDisplayedColumns];
    } else {
      this.patientId = resolvedPatientId ?? encounterPatientId;
      this.labRequestsDisplayedColumns = [...this.baseDisplayedColumns];
    }

    // If custom columns are provided, use them instead of defaults
    if (this.labRequestTableColumns && this.labRequestTableColumns.length > 0) {
      this.labRequestsDisplayedColumns = this.labRequestTableColumns;
    } else {
      this.labRequestsDisplayedColumns = [...this.baseDisplayedColumns];
    }

    if (!this.patientId) {
      this.searchableFields = [
        { label: 'Patient ID', value: 'subject:Patient.identifier' },
        { label: 'Requisition ID', value: 'requisition' },
        { label: 'Service Name', value: 'code:text' }
      ];
    } else {
      this.searchableFields = [
        { label: 'Requisition ID', value: 'requisition' },
        { label: 'Service Name', value: 'code:text' }
      ];
      this.selectedSearchField = 'requisition';
    }

    this.srSearch.init('Laboratory', this.patientId);

    combineLatest([
      this.srSearch.dataSource.connect(),
      this.availabilitySets$
    ]).pipe(takeUntil(this.destroy$)).subscribe(([rows, availabilitySets]) => {
      this.labRequests = rows.map(r => (r as any).actualResource || (r as any).rawResource) as ServiceRequest[];
      
      // Inject required side-data fetched via ServiceRequestSearchService into the actual resource
      this.labRequests.forEach((e: any, index: number) => {
          const rowData: any = rows[index];
          console.log('Injecting side-data into ServiceRequest:', e.id, rowData);
          e.relatedChargeItems = rowData.relatedChargeItems || [];
          e.relatedInvoices = rowData.relatedInvoices || [];
          e.hasBalancedInvoice = !!rowData.hasBalancedInvoice;
          e.available = this.computeServiceAvailabilityLabel(e, availabilitySets);
          if (e.note && Array.isArray(e.note)) {
              e.flattenedNote = e.note.map((n: any) => n.text).join(' | ');
          }
      });

      // Apply grouping logic on the current page's data
      const sortedAccRequisition: { [key: string]: ServiceRequest[] } = {};
      this.labRequests?.forEach((e: ServiceRequest) => {
        if (e.hasOwnProperty('requisition') && e.requisition?.hasOwnProperty('value')) {
          if (!sortedAccRequisition.hasOwnProperty(e.requisition!.value!)) {
            sortedAccRequisition[e.requisition!.value!] = [];
          }
          sortedAccRequisition[e.requisition!.value!].push(e);
        } else {
          sortedAccRequisition['N/A'] = sortedAccRequisition['N/A'] || [];
          sortedAccRequisition['N/A'].push(e);
        }
      });

      this.sortedWithRequisition = sortedAccRequisition;
      this.sortedWithRequisitionKeys = Object.keys(sortedAccRequisition);
      
      const flatData: any[] = [];
      Object.values(this.sortedWithRequisition).forEach((group) => {
        flatData.push(...group);
      });
      
      this.tableDataLevel2.next(flatData);
      this.tableDataSource.data = flatData;
      this.tableDataSource.sort = this.sort;
      
      this.autoOpenDialogFromRoute();
    });

    this.resourceRefresh.onRefresh('ServiceRequest').pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.srSearch.refresh();
    });
  }

  onSearchCriteriaChanged(criteria: any): void {
    //previous tabledata
    console.log('Previous table data:', this.tableDataLevel2.getValue());
    console.log('Search criteria changed:', criteria);
    const filters: any = {};
    const field = criteria.field || this.selectedSearchField;
    const term = criteria.term;
    if (term && field) {
      filters[field] = term;
    }

    if (criteria?.status && criteria.status.length > 0) {
      filters.status = criteria.status.join(',');
    }
    this.srSearch.search(filters);
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.paginatorPageIndex = event.pageIndex;
    this.srSearch.changePage(event.pageIndex);
  }

  async transformLabRequestWithBilling(row: any): Promise<any> {
    const base = row as ServiceRequest;
    if (!base?.subject?.reference || !base?.id) {
      return base;
    }
    try {
      const patientId = base.subject.reference.split("/")[1];
      const cIAndInv = await firstValueFrom(this.sRServ.getChargeItemAndInvoice(patientId, base.id, this.chargeItemsReserve, this.invoicesReserve));
      const transformed: any = { ...base, relatedChargeItems: cIAndInv.chargeItems, relatedInvoices: cIAndInv.invoices, flattenedNote: (base.note || []).map(n => n.text).join(' | ') };
      return transformed;
    } catch (error) {
      console.warn('Failed to fetch billing data for lab request:', base.id, error);
      return base;
    }
  }

  /**
   * Enriches a raw ServiceRequest with billing data, formatted notes, and availability status.
   * This ensures that requests opened directly via URL have the same rich data as those in the table.
   */
  async enrichLabRequest(sr: ServiceRequest): Promise<any> {
    if (!sr?.id || !sr?.subject?.reference) {
      return sr;
    }

    try {
      const patientId = sr.subject.reference.split("/")[1];
      
      // 1. Fetch Billing Data using the specialized placeholder service
      const billing = await firstValueFrom(
        this.billingPlaceholder.resolveBillingAndPlaceholderForLab(sr, patientId)
      );

      // 2. Fetch availability sets to compute 'Available' label
      const availabilitySets = await firstValueFrom(this.availabilitySets$);

      const enriched: any = {
        ...sr,
        relatedChargeItems: billing.chargeItem ? [billing.chargeItem] : [],
        relatedInvoices: billing.linkedInvoices || [],
        hasBalancedInvoice: !!billing.hasBalancedInvoice,
        flattenedNote: (sr.note || []).map(n => n.text).join(' | '),
        available: this.computeServiceAvailabilityLabel(sr, availabilitySets)
      };

      return enriched;
    } catch (error) {
      console.warn('Failed to enrich lab request:', sr.id, error);
      return {
        ...sr,
        relatedChargeItems: [],
        relatedInvoices: [],
        flattenedNote: (sr.note || []).map(n => n.text).join(' | ')
      };
    }
  }

  dialog = inject(MatDialog)
  private requestPrint = inject(RequestPrintService);
  private cachedOrganization: Organization | null = null;

  printLabGroup(requisitionId: string | null | undefined): void {
    const id = (requisitionId ?? '').toString().trim();
    if (!id) {
      this.errorService.openandCloseError('Requisition (group id) is missing.');
      return;
    }

    const rows = this.sortedWithRequisition?.[id] ?? [];
    if (!rows.length) {
      this.errorService.openandCloseError(`No lab requests found for group: ${id}`);
      return;
    }

    this.requestPrint.printLabRequestGroup(id, rows);
  }

  detailsBuilder: DetailsBuilderObject = {
    resourceName: 'Lab Request',
    resourceIcon: 'biotech',
    specialHeader: {
      strongSectionKey: 'code',
      iconSectionKeys: ['status', 'priority', 'available'],
      contentSectionKeys: ['subject', 'authoredOn']
    },
    groups: [
      { groupName: 'Classification', groupIcon: 'category', groupKeys: ['status', 'intent', 'priority', 'performerType'] },
      { groupName: 'Participants', groupIcon: 'group', groupKeys: ['subject', 'requester', 'performer'] },
      { groupName: 'Clinical Details', groupIcon: 'science', groupKeys: ['code', 'reasonCode', 'flattenedNote'] },
      { groupName: 'Logistics', groupIcon: 'calendar_today', groupKeys: ['authoredOn', 'requisition'] }
    ]
  };

  async showRow(row: ServiceRequest): Promise<MatDialogRef<DetailzViewzComponent>> {
    const actionButtons = await firstValueFrom(
      this.sRServ.filterVisibleActions$(this.buildLabRequestActions(row as any), row, { currentTabType: 'laboratory' })
    );

    const dialogRef = this.dialog.open(DetailzViewzComponent, {
      maxHeight: '93vh',
      maxWidth: '90vh',
      data: {
        resourceData: row,
        detailsBuilderObject: this.detailsBuilder,
        actionButtons
      }
    });

    const sub = dialogRef.componentInstance?.actionInvoked.subscribe(({ key }) => {
      this.handleDetailAction(key, row);
    });
    dialogRef.afterClosed().subscribe(() => sub?.unsubscribe());

    return dialogRef;
  }

  private async autoOpenDialogFromRoute(): Promise<void> {
    if (!this.serviceRequestIdFromRoute || this.autoDialogOpened) {
      return;
    }
    
    // Set immediately to prevent race conditions during async operations
    this.autoDialogOpened = true;

    // First try to find in existing data (use labRequests which is populated, not rawLabRequests)
    let target = (this.labRequests && this.labRequests.length > 0)
      ? this.labRequests.find((request: any) => request?.id === this.serviceRequestIdFromRoute)
      : null;

    if (target) {
      // Found in cache, proceed normally
      setTimeout(async () => {
        // Ensure availability info is present even for cached resources
        const enriched = await this.enrichLabRequest(target);
        this.showRow(enriched);
        void this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { ...this.route.snapshot.queryParams, serviceRequestId: null },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      });
      return;
    }

    // Not found in cache, try to fetch individually
    try {
      const fetched = await this.fetchLabRequestById(this.serviceRequestIdFromRoute);
      if (fetched) {
        this.autoDialogOpened = true;
        
        // Enrich the fetched resource before showing it
        const enriched = await this.enrichLabRequest(fetched);
        
        setTimeout(async () => {
          const dialogRef = await this.showRow(enriched);
          
          // When the dialog is closed, refresh the table so this "new" record 
          // (which wasn't in the list before) now appears in the table.
          dialogRef.afterClosed().subscribe(() => {
            this.srSearch.refresh();
          });

          void this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { ...this.route.snapshot.queryParams, serviceRequestId: null },
            queryParamsHandling: 'merge',
            replaceUrl: true
          });
        });
      }
    } catch (error) {
      console.error('Error in auto-opening lab request:', error);
    }
  }

  private async fetchLabRequestById(id: string | null): Promise<ServiceRequest | null> {
    if (!id || !id.trim()) {
      return null;
    }

    try {
      const url = `${this.backendEndPoint}/ServiceRequest/${encodeURIComponent(id.trim())}`;
      const resource = await firstValueFrom(
        this.http.get<ServiceRequest>(url).pipe(
          catchError((error) => {
            console.warn(`ServiceRequest/${id} not found on backend:`, error);
            return of(null);
          })
        )
      );
      return resource;
    } catch (error) {
      console.error('Error fetching ServiceRequest by ID:', error);
      return null;
    }
  }

  private computeServiceAvailabilityLabel(
    sr: ServiceRequest | any,
    sets: { pairSet: Set<string>; codeSet: Set<string>; displaySet?: Set<string> }
  ): 'Available' | 'Not Available' {
    const codings = Array.isArray(sr?.code?.coding) ? sr.code.coding : [];

    for (const coding of codings) {
      const code = (coding?.code || '').toString().trim().toLowerCase();
      const system = (coding?.system || '').toString().trim().toLowerCase();
      const display = (coding?.display || '').toString().trim().toLowerCase();

      if (code) {
        // const key = system ? `${system}::${code}` : '';
        const ok = sets.codeSet.has(code);
        if (ok) return 'Available';
      }
      if (display && sets.displaySet?.has(display)) return 'Available';
    }

    const text = (sr?.code?.text || '').toString().trim().toLowerCase();
    if (text) {
      if (sets.displaySet?.has(text)) return 'Available';
      if (sets.codeSet.has(text)) return 'Available';
    }

    return 'Not Available';
  }

  alltds(td: HTMLTableCellElement): void {
// $#$    // /* alert(td!.parentElement!.innerHTML); */
    const tdArr = Array.from(document.getElementsByTagName("td")) as HTMLElement[]
    tdArr.forEach((e => { e!.parentElement!.style.zIndex = "99999" }));
    (td as HTMLElement).parentElement!.style.zIndex = "999999999999999999";
    (td as HTMLElement).parentElement!.style!.overflow = "visible"
  }

  isLinkObj: { [key: string]: Map<number, string | null> } = {};
  islink = inject(LinkInReferencesService)

  showSpecimenForThisTest() {
// $#$    // /* alert(this.utilityService.getPatientIdFromRoute() */ || this.patientId);
    this.dialog.open(SpecimenDetailsComponent, {
      maxWidth: '450px',
      maxHeight: '90vh',
      panelClass: 'visible-overflow',
      data: {
        specimenDetails: null,

      }

    })
  }

  hasActiveFilters(): boolean {
    const hasPriority = !!this.priorityFilterControl.value?.length;
    const hasStatus = !!this.statusFilterControl.value?.length;
    return hasPriority || hasStatus;
  }


  removePriorityFilter(value: string): void {
    const current = this.priorityFilterControl.value || [];
    this.priorityFilterControl.setValue(current.filter(v => v !== value));
  }

  removeStatusFilter(value: string): void {
    const current = this.statusFilterControl.value || [];
    this.statusFilterControl.setValue(current.filter(v => v !== value));
  }

  clearAllFilters(): void {
    this.priorityFilterControl.setValue([]);
    this.statusFilterControl.setValue([]);
  }

  // Update applyFormControlFilters method
  private applyFormControlFilters(items: ServiceRequest[]): ServiceRequest[] {
    let filtered = [...items];

    // Apply priority filter
    const selectedPriorities = this.priorityFilterControl.value;
    if (selectedPriorities && selectedPriorities.length > 0) {
      filtered = filtered.filter((item: any) => {
        const itemPriority = this.normalizeValue(item.priority?.display || item.priority);
        return selectedPriorities.some(p => this.normalizeValue(p) === itemPriority);
      });
    }

    // Apply status filter
    const selectedStatuses = this.statusFilterControl.value;
    if (selectedStatuses && selectedStatuses.length > 0) {
      filtered = filtered.filter((item: any) => {
        const itemStatus = this.normalizeValue(item.status);
        return selectedStatuses.some(s => this.normalizeValue(s) === itemStatus);
      });
    }

    return filtered;
  }

  showResultsForThisTest(element: ServiceRequest) {
// $#$    // /* alert("Show Results for this test"); */
    console.log(element);

  }
  showDetails(element: ServiceRequest) {
// $#$    // /* alert("Show Details for this test"); */
    console.log(element);
    this.dialog.open(LabrequestDetailsComponent, {
      maxWidth: '450px',
      maxHeight: '90vh',
      panelClass: 'visible-overflow',
      data: {
        serviceRequest: element,
        patientId: this.utilityService.getPatientIdFromRoute() || this.patientId,

      }
    })
  }

  showReport() {
// $#$    // /* alert("Show Report for this test"); */
    console.log("Show Report for this test");
    this.dialog.open(LabreportComponent, {
      maxWidth: '900px',
      maxHeight: '90vh',

    })
  }

  async showGroupReport(requisitionId: string | null | undefined): Promise<void> {
    const id = (requisitionId ?? '').toString().trim();
    if (!id) {
      this.errorService.openandCloseError('Requisition (group id) is missing.');
      return;
    }

    const rows = this.sortedWithRequisition?.[id] ?? [];
    if (!rows.length) {
      this.errorService.openandCloseError(`No lab requests found for group: ${id}`);
      return;
    }

    // best-effort patient id from first row
    const patientId = this.extractPatientId(rows[0]) ?? this.utilityService.getPatientIdFromRoute() ?? this.patientId ?? null;
    if (!patientId) {
      this.errorService.openandCloseError('Cannot open group report: Patient context not found.');
      return;
    }

    // Minimal: require payment for all requests before opening the report dialog.
    try {
      const paymentChecks = await firstValueFrom(
        forkJoin(
          (rows || []).map((sr) =>
            this.billingPlaceholder.resolveBillingAndPlaceholderForLab(sr, patientId).pipe(
              map((r) => r?.hasBalancedInvoice === true),
              catchError(() => of(false))
            )
          )
        ).pipe(catchError(() => of([] as boolean[])))
      );

      const allPaid = (paymentChecks || []).length > 0 && (paymentChecks || []).every((x) => x === true);
      if (!allPaid) {
        this.errorService.openandCloseError('Payment has not been made for one or more lab requests in this group (Invoice must be balanced).');
        return;
      }
    } catch {
      this.errorService.openandCloseError('Failed to verify payment status for this group report.');
      return;
    }

    this.dialog.open(AddReportComponent, {
       maxWidth: '95vw',
      
      width: '650px',
      maxHeight: '90vh',
      autoFocus: false,
      disableClose: true,
      data: {
        serviceRequests: rows,
        serviceRequestIds: rows.map((r) => r.id),
        patientId,
        requisitionId: id
      }
    });
  }
  addLabResults(patientId: string | null = null, serviceRequest?: ServiceRequest) {
    if (!serviceRequest?.id) {
      this.errorService.openandCloseError('Cannot add lab results: ServiceRequest is missing an id.');
      return;
    }
    if (serviceRequest.status !== 'active') {
      this.errorService.openandCloseError('Cannot add results to a lab request that is not active.');
      return;
    }

    const resolvedPatientId = patientId ?? this.extractPatientId(serviceRequest) ?? null;
    if (!resolvedPatientId) {
      this.errorService.openandCloseError('Cannot add lab results: Patient id could not be resolved.');
      return;
    }

    this.billingPlaceholder.resolveBillingAndPlaceholderForLab(serviceRequest, resolvedPatientId).subscribe(({ observations, selectedObservation, chargeItem, hasBalancedInvoice }) => {
      const list = Array.isArray(observations) ? observations : [];
      if (!list.length) {
        this.errorService.openandCloseError('No lab observation found linked to this lab request. Please contact support.');
        return;
      }

      // const openEditor = (obs: Observation) => {
      // Pre-warning: user can still draft (registered/preliminary), but final results require payment.
      if (!hasBalancedInvoice) {
        this.errorService.openandCloseError(
          'Payment not confirmed. Please confirm payment to add results.'
        );
        return;
      }

      // this.dialog.open(AddObservationComponent, {
      //   maxHeight: '90vh',
      //   maxWidth: '650px',
      //   autoFocus: false,
      //   data: {
      //     isAnyCategory: false,
      //     observationCategoryValue: 'laboratory',
      //     patientId: resolvedPatientId,
      //     serviceRequest,
      //     existingObservation: obs,
      //     chargeItem,
      //     enforcePaymentForFinal: true,
      //     paymentBalanced: hasBalancedInvoice
      //   }
      // });
      // };

      // const preferred = selectedObservation || list[0];
      // if (list.length > 1) {
      //   this.dialog.open(ObservationSelectorDialogComponent, {
      //     maxWidth: '650px',
      //     maxHeight: '90vh',
      //     autoFocus: false,
      //     data: {
      //       title: 'Select which lab test to fill',
      //       observations: list,
      //       preselectedId: preferred?.id
      //     }
      //   }).afterClosed().subscribe((chosen: Observation | undefined) => {
      //     if (!chosen) return;
      //     openEditor(chosen);
      //   });
      //   return;
      // }

      // if (!preferred) {
      //   this.errorService.openandCloseError('No lab observation found linked to this lab request. Please contact support.');
      //   return;
      // }
      // openEditor(preferred);
      this.dialog.open(RequiredObservationResultsTableComponent, {
        maxWidth: '900px',
        maxHeight: '90vh',
        autoFocus: false,
        data: {
          serviceRequest,
          patientId: resolvedPatientId,
          chargeItem,
          enforcePaymentForFinal: true,
          paymentBalanced: hasBalancedInvoice
        }
      });
      // });
    });
  }

  private resolveBillingAndPlaceholderForLab(
    serviceRequest: ServiceRequest,
    patientId: string,
    returnInvoice?: boolean
  ): Observable<{ observations: Observation[]; selectedObservation: Observation | null; chargeItem: ChargeItem | null; hasBalancedInvoice: boolean, invoice?: Invoice | null }> {
    const srRef = `ServiceRequest/${serviceRequest.id}`;
    let originalFromStateObs: {
      actualResource: Observation,
      referenceId: string | null,
      savedStatus: "saved" | "unsaved"

    }[] | [] = [];
    const processBundle = (bundle: Bundle<any>) => {
      const currentPatientId = this.stateService.currentPatientId$.getValue();
      const isCurrentPatient = !!currentPatientId && currentPatientId === patientId;
      if (isCurrentPatient) {
        this.stateService.processBundleTransaction(bundle as any);
        originalFromStateObs = (this.stateService.PatientResources.observations.getValue() || [])
      } else {
        this.stateService.processOrgWideBundleTransaction(bundle as any);
        originalFromStateObs = (this.stateService.orgWideResources.observations.getValue() || [])
      }
    };

    const fromStateObs = (originalFromStateObs || [])
      .map((w) => w.actualResource)
      .filter((o: any) => referenceArrayContains(o?.basedOn, srRef)) as Observation[];

    const fetchByBasedOn$ = this.http
      // .get<Bundle<Observation>>(`${this.backendEndPoint}/Observation?based-on=${encodeURIComponent(srRef)}&subject=Patient/${patientId}&_count=1000`)
      .get<Bundle<Observation>>(`${this.backendEndPoint}/Observation?subject=Patient/${patientId}&_count=1000`)
      .pipe(
        tap((list) => {
          console.log('Fetched observations by based-on for SR:', srRef, list);
          processBundle(list as any);
        }),
        map((b: any) => (b?.entry || []).map((e: any) => e?.resource).filter(Boolean) as Observation[]),
        map((list: Observation[]) => (list || []).filter((o: any) => referenceArrayContains(o?.basedOn, srRef))),

        catchError(() => of([] as Observation[]))
      );

    const fetchBySubject$ = this.http
      .get<Bundle<Observation>>(`${this.backendEndPoint}/Observation?subject=${encodeURIComponent(`Patient/${patientId}`)}&_count=1000`)
      .pipe(
        tap((bundle) => processBundle(bundle as any)),
        map((b: any) => (b?.entry || []).map((e: any) => e?.resource).filter(Boolean) as Observation[]),
        map((list: Observation[]) => (list || []).filter((o: any) => referenceArrayContains(o?.basedOn, srRef))),
        catchError(() => of([] as Observation[]))
      );

    const obs$ = fromStateObs.length
      ? of(fromStateObs)
      : fetchByBasedOn$.pipe(
        switchMap((list: Observation[]) => (list?.length ? of(list) : fetchBySubject$))
      );

    const fromStateChargeItems = (this.stateService.PatientResources.chargeItems.getValue() || []).map((w) => w.actualResource);
    const fromStateInvoices = (this.stateService.PatientResources.invoices.getValue() || []).map((w) => w.actualResource);

    const chargeItems$ = fromStateChargeItems.length
      ? of(fromStateChargeItems)
      : this.http
        .get<Bundle<ChargeItem>>(`${this.backendEndPoint}/ChargeItem?subject=${encodeURIComponent(`Patient/${patientId}`)}&_count=1000`)
        .pipe(
          tap((bundle) => processBundle(bundle as any)),
          map((b: any) => (b?.entry || []).map((e: any) => e?.resource).filter(Boolean) as ChargeItem[]),
          catchError(() => of([] as ChargeItem[]))
        );

    const invoices$ = fromStateInvoices.length
      ? of(fromStateInvoices)
      : this.http
        .get<Bundle<Invoice>>(`${this.backendEndPoint}/Invoice`)
        //?subject=${encodeURIComponent(`Patient/${patientId}`)}&_count=1000`)
        .pipe(
          tap((bundle) => processBundle(bundle as any)),
          map((b: any) => (b?.entry || []).map((e: any) => e?.resource).filter(Boolean) as Invoice[]),
          catchError(() => of([] as Invoice[]))
        );

    return forkJoin({ observations: obs$, chargeItems: chargeItems$, invoices: invoices$ }).pipe(
      map(({ observations, chargeItems, invoices }) => {
        console.log('Resolved observations, charge items, invoices for SR:', srRef, { observations, chargeItems, invoices });
        const obsList = (observations || []) as Observation[];
        const byRef = new Map<string, Observation>();
        for (const o of obsList) {
          if (!o?.id) continue;
          byRef.set(`Observation/${o.id}`, o);
        }

        const isBalancedForChargeItem = (ci: any): boolean => {
          const chargeItemRef = ci?.id ? `ChargeItem/${ci.id}` : null;
          if (!chargeItemRef) return false;
          return (invoices || []).some((inv: any) => {
            const status = (inv?.status || '').toString().toLowerCase();
            if (status !== 'balanced') return false;
            const lineItems = inv?.lineItem || [];
            return lineItems.some((li: any) => {
              const ref = (li?.chargeItemReference?.reference || '').toString();
              return ref === chargeItemRef || ref.endsWith(chargeItemRef);
            });
          });
        };


        const isBalancedForChargeItemInv = (ci: any): [boolean, Invoice | null] => {
          const chargeItemRef = ci?.id ? `ChargeItem/${ci.id}` : null;
          if (!chargeItemRef) return [false, null];
          const toReturn = (invoices || []).find((inv: any) => {
            const status = (inv?.status || '').toString().toLowerCase();
            if (status !== 'balanced') return false;
            const lineItems = inv?.lineItem || [];
            return lineItems.some((li: any) => {
              const ref = (li?.chargeItemReference?.reference || '').toString();
              return ref === chargeItemRef || ref.endsWith(chargeItemRef);
            });
          });
          if (toReturn) {
            return [true, toReturn];
          }
          return [false, null];
        };

        const matchesAnyObservation = (ref: string): { obsRef: string; obs: Observation } | null => {
          if (!ref) return null;
          if (byRef.has(ref)) return { obsRef: ref, obs: byRef.get(ref)! };
          for (const [obsRef, obs] of byRef.entries()) {
            if (referenceMatches(ref, obsRef)) return { obsRef, obs };
          }
          return null;
        };

        const linkedChargeItems: Array<{ chargeItem: ChargeItem; observation: Observation; balanced: boolean }> = [];
        for (const ci of (chargeItems || []) as any[]) {
          const services = ci?.service || [];
          for (const s of services) {
            const ref = (s?.reference || '').toString();
            const match = matchesAnyObservation(ref);
            if (match) {
              linkedChargeItems.push({
                chargeItem: ci as ChargeItem,
                observation: match.obs,
                balanced: isBalancedForChargeItem(ci),
                ...(returnInvoice ? { invoice: isBalancedForChargeItemInv(ci)[1] } : {})
              });
              break;
            }
          }
        }


        console.log('Linked charge items to observations:', linkedChargeItems);

        const preferredLinked =
          linkedChargeItems.find((x) => x.balanced) ||
          linkedChargeItems[0] ||
          null;

        const fallbackObservation =
          obsList.find((o: any) => (o?.status || '').toString().toLowerCase() === 'registered') ||
          obsList[0] ||
          null;

        const selectedObservation = preferredLinked?.observation || fallbackObservation;
        const chargeItem = preferredLinked?.chargeItem || null;
        const hasBalancedInvoice = preferredLinked?.balanced === true;

        return { observations: obsList, selectedObservation, chargeItem, hasBalancedInvoice };
      })
    );
  }
  private snackBar = inject(MatSnackBar);
  private buildLabRequestActions(row?: ServiceRequest & any): DetailActionButton[] {
    //determined by three things  - user permissions, request status, payment status (for results)
    if ((row as any)?.available !== 'Available') {
      return [
        {
          key: 'printLabRequest',
          label: 'Print Lab Request',
          icon: 'print',
          color: 'primary',
          visibility: { includedStatus: ['active'] },
          ignoreCapabilities: true
        },
        {
          key: 'viewResults',
          label: 'View Results',
          icon: 'visibility',
          color: 'primary',
          ignoreCapabilities: true,
          visibility: { includedStatus: ['active', 'completed'] },
          capabilities: [{ resource: 'labRequest', action: 'request' }]
        },
        // {
        //   key: 'printLabRequest',
        //   label: 'Print Lab Request',
        //   icon: 'print',
        //   color: 'primary',
        //   ignoreCapabilities: true
        // },
        // {
        //   key: 'editRequest',
        //   label: 'Edit Request',
        //   icon: 'edit',
        //   color: 'primary',
        //   ignoreCapabilities: true,
        //   visibility: { includedStatus: ['draft'] },
        //   capabilities: [{ resource: 'labRequest', action: 'update' }]


        // },
        {
          key: 'revokeRequest',
          label: 'Revoke Request',
          // it must to b noted that revoke must do additional checks as to whether payments have been made,
          // if payment has not been made, related invoie should be cancelled. otherwise,nothing is done concernning
          //financial aspect as payment might have trigerred the use of resources and cost acurring
          // regardless in both ways, revoke should be allowed, sine the payment is for the actual test, not request
          icon: 'block',
          color: 'warn',

          ignoreCapabilities: true,
          visibility: { includedStatus: ['active', 'on-hold'] },
          capabilities: [{ resource: 'labRequest', action: 'revoke' }]
        },
      ];
    }
    return [
      {
        key: 'printLabRequest',
        label: 'Print Lab Request',
        icon: 'print',
        color: 'primary',
        visibility: { includedStatus: ['active'] },
        ignoreCapabilities: true
      },
      {
        key: 'addSpecimen',
        label: 'Add Specimen',
        icon: 'science',
        color: 'primary',
        ignoreCapabilities: true,
        visibility: { includedStatus: ['active'] },
        capabilities: [{ resource: 'labRequest', action: 'fulfill' }]
      },
      //view results
      // {
      //   key: 'viewResults',
      //   label: 'View Results',
      //   icon: 'visibility',
      //   color: 'primary',
      //   ignoreCapabilities: true,
      //   capabilities: [{ resource: 'observation', action: 'view' }]
      // },
      {
        key: 'addResult',
        label: 'Results',
        icon: 'biotech',
        color: 'accent',
        ignoreCapabilities: true,
        visibility: { includedStatus: ['active'] },
        capabilities: [{ resource: 'labRequest', action: 'fulfill' }]
      },
      {
        key: 'viewResults',
        label: 'View Results',
        icon: 'visibility',
        color: 'primary',
        ignoreCapabilities: true,
        visibility: { includedStatus: ['active', 'completed'] },
        capabilities: [{ resource: 'labRequest', action: 'request' }]
      },
      {
        key: 'editItemsRequired',
        label: 'Confirm Items Used',
        icon: 'fact_check',
        color: 'primary',
        ignoreCapabilities: true,
        visibility: { includedStatus: ['active'] },
        capabilities: [{ resource: 'labRequest', action: 'fulfill' }]
      },
      // {
      //   key: 'addSpecimen',
      //   label: 'Add Specimen',
      //   icon: 'science',
      //   color: 'primary',
      //   ignoreCapabilities: true,
      //   visibility: { includedStatus: ['active'] },
      //   capabilities: [{ resource: 'labRequest', action: 'fulfill' }]
      // },
      // // {
      // //   key: 'changeStatus',
      // //   label: 'Change Status',
      //   icon: 'sync',
      //   color: 'warn',
      //   ignoreCapabilities: true,
      //   capabilities: [{ resource: 'labRequest', action: 'update' }]
      // },
      //resume button for on-hold status, revoke for active and on-hold, cancel for draft
      {
        key: 'cancelRequest',
        label: 'Cancel Request',
        icon: 'cancel',
        color: 'warn',
        ignoreCapabilities: true,
        visibility: { includedStatus: ['draft'] },
        capabilities: [{ resource: 'labRequest', action: 'update' }]
      },
      //edit if it is in draft status
      // {
      //   key: 'editRequest',
      //   label: 'Edit Request',
      //   icon: 'edit',
      //   color: 'primary',
      //   ignoreCapabilities: true,
      //   visibility: { includedStatus: ['draft'] },
      //   capabilities: [{ resource: 'labRequest', action: 'update' }]


      // },
      {
        key: 'revokeRequest',
        label: 'Revoke Request',
        // it must to b noted that revoke must do additional checks as to whether payments have been made,
        // if payment has not been made, related invoie should be cancelled. otherwise,nothing is done concernning
        //financial aspect as payment might have trigerred the use of resources and cost acurring
        // regardless in both ways, revoke should be allowed, sine the payment is for the actual test, not request
        icon: 'block',
        color: 'warn',

        ignoreCapabilities: true,
        visibility: { includedStatus: ['active', 'on-hold'] },
        capabilities: [{ resource: 'labRequest', action: 'revoke' }]
      },
      {
        //resume button
        key: 'resumeRequest',
        label: 'Resume Request',
        icon: 'play_arrow',
        color: 'primary',
        ignoreCapabilities: true,
        visibility: { includedStatus: ['on-hold'] },
        capabilities: [{ resource: 'labRequest', action: 'update' }]
      },
      //see attached speimen
      {
        key: 'viewSpecimen',
        label: 'View Specimen',
        icon: 'visibility',
        color: 'primary',
        ignoreCapabilities: true,
        visibility: { includedStatus: ['active'] },
        capabilities: [{ resource: 'labRequest', action: 'view' }]
      }

    ];
  }

  private handleDetailAction(actionKey: string, row: ServiceRequest) {
    switch (actionKey) {
      case 'printLabRequest':
        this.printSingleLabRequest(row);
        break;
      case 'addSpecimen':
        this.launchSpecimenDialog(row);
        break;
      case 'addResult':
        this.launchResultDialog(row);
        break;
      case 'changeStatus':
        this.promptStatusChange(row);
        break;
      case 'viewResults':
        this.launchViewResultsDialog(row);
        break;
      case 'revokeRequest':
        this.revokeLabRequest(row as any);
        break;
      case 'editItemsRequired': {
        const patientId = this.extractPatientId(row) ?? this.patientId ?? '';
        if (!patientId) {
          this.errorService.openandCloseError('Patient context not found for this lab request.');
          return;
        }

        this.dialog.open(ItemsRequiredEditorComponent, {
          maxWidth: '750px',
          maxHeight: '90vh',
          autoFocus: false,
          disableClose: true,
          data: {
            serviceRequest: row,
            patientId
          }
        });
        break;
      }
      default:
        break;
    }
  }

  private revokeLabRequest(row: ServiceRequest & any): void {
    const srId = (row?.id ?? '').toString().trim();
    if (!srId) {
      this.errorService.openandCloseError('Cannot revoke: ServiceRequest id is missing.');
      return;
    }

    const currentStatus = (row?.status ?? '').toString().trim().toLowerCase();
    if (currentStatus === 'revoked') {
      this.infoDialog.info('This lab request is already revoked.', 3500);
      return;
    }

    const patientId = this.extractPatientId(row) ?? this.patientId ?? '';

    const confirmRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '520px',
      data: {
        title: 'Revoke Lab Request?'
        ,
        message: 'This will set the lab request status to REVOKED.\n\nIf payment has NOT been made (Invoice not BALANCED), the related invoice will be set to CANCELLED.'
        ,
        confirmText: 'Revoke'
        ,
        cancelText: 'Back'
        ,
        icon: 'warning'
      }
    });

    confirmRef.afterClosed().subscribe((ok: boolean) => {
      if (ok !== true) return;

      // const maybeChargeItems = Array.isArray((row as any)?.relatedChargeItems) ? ((row as any).relatedChargeItems as ChargeItem[]) : null;
      // const maybeInvoices = Array.isArray((row as any)?.relatedInvoices) ? ((row as any).relatedInvoices as Invoice[]) : null;

      const persistMode: 'auto' | 'patient' | 'org' = this.useOrgWideServiceRequests ? 'org' : 'patient';

      this.billingPlaceholder.resolveBillingAndPlaceholderForLab(row, patientId).pipe(
        take(1),
        map((labBilling) => {
          const chargeItem = labBilling?.chargeItem ?? null;
          if (!chargeItem && row.relatedChargeItems && Array.isArray(row.relatedChargeItems) && row.relatedChargeItems.length > 0) {
            throw new Error('No linked ChargeItem found for this lab request. Cannot determine billing status.');
          }

          const fallbackInvoices: Invoice[] = Array.isArray((row as any)?.relatedInvoices)
            ? (((row as any).relatedInvoices as any[]).filter(Boolean) as Invoice[])
            : [];

          const invoices = (labBilling?.linkedInvoices?.length ? labBilling.linkedInvoices : fallbackInvoices) ?? [];
          const hasBalancedInvoice = labBilling?.hasBalancedInvoice ?? false;
          return { hasBalancedInvoice, invoices };
        }),
        switchMap(({ hasBalancedInvoice, invoices }) => {
          const srPut$ = this.statusChanges
            .changeResourceStatus('ServiceRequest', srId, 'revoked', persistMode)
            .pipe(
              catchError((e) => {
                console.error('Failed to revoke ServiceRequest', srId, e);
                this.errorService.openandCloseError('Failed to revoke this lab request.');
                return of(null);
              })
            );

          if (hasBalancedInvoice) {
            return forkJoin({ sr: srPut$, inv: of([] as any[]) }).pipe(
              map(() => ({ cancelledInvoices: 0, paid: true }))
            );
          }

          const idsToCancel = Array.from(
            new Set(
              (invoices || [])
                .filter((inv: any) => {
                  const st = (inv?.status ?? '').toString().toLowerCase();
                  return st && st !== 'balanced' && st !== 'cancelled' && st !== 'entered-in-error';
                })
                .map((inv: any) => (inv?.id ?? '').toString().trim())
                .filter(Boolean)
            )
          );

          if (!idsToCancel.length) {
            return forkJoin({ sr: srPut$, inv: of([] as any[]) }).pipe(
              map(() => ({ cancelledInvoices: 0, paid: false }))
            );
          }

          const invPuts$ = forkJoin(
            idsToCancel.map((invoiceId) =>
              this.statusChanges.changeResourceStatus('Invoice', invoiceId, 'cancelled', persistMode).pipe(
                catchError((e) => {
                  console.error('Failed to cancel Invoice', invoiceId, e);
                  // best-effort: still revoke SR even if invoice cancel fails
                  return of(null);
                })
              )
            )
          );

          return forkJoin({ sr: srPut$, inv: invPuts$ }).pipe(
            map(() => ({ cancelledInvoices: idsToCancel.length, paid: false }))
          );
        })
      ).subscribe(({ cancelledInvoices, paid }) => {
        // No local optimistic patch here: `ResourceStatusChangesService` persists into `StateService`
        // which will re-emit through `serviceRequestsSource` and refresh this table.
        if (paid) {
          this.snackBar.open('Lab request revoked. Payment already made, invoice unchanged.', 'Dismiss', { duration: 4500 });
          return;
        }
        if (cancelledInvoices > 0) {
          this.snackBar.open(`Lab request revoked. Cancelled ${cancelledInvoices} unpaid invoice(s).`, 'Dismiss', { duration: 4500 });
          return;
        }
        this.snackBar.open('Lab request revoked. No related unpaid invoice found to cancel.', 'Dismiss', { duration: 4500 });
      });
    });
  }

  private promptStatusChange(row: ServiceRequest) {
    const label = row?.id ?? 'request';
    this.snackBar.open(`Change status clicked for ${label}`, 'Dismiss', { duration: 2500 });
  }

  getOrganizationTenantId(serviceRequest: ServiceRequest): string | null {
    if (!serviceRequest) {
      return null;
    }

    // Primary source: meta.tag populated by loading.interceptor with the tenant system tag
    const tags: any[] = Array.isArray(serviceRequest?.meta?.tag) ? serviceRequest.meta.tag : [];
    const tenantTag = tags.find((coding: any) => this.isOrganizationTenantSystem(coding?.system));
    const tenantFromTag = this.normalizeOrganizationId(tenantTag?.code ?? tenantTag?.value);
    if (tenantFromTag) {
      return tenantFromTag;
    }

    // Fallback: legacy extensions (hospitalId / actor-organization / organizationTenant)
    const extensions: any[] = Array.isArray(serviceRequest?.extension) ? serviceRequest.extension : [];
    const tenantExtension = extensions.find((ext: any) =>
      this.isOrganizationTenantExtension(ext?.url) || this.isLegacyOrganizationExtension(ext?.url)
    );
    const extensionValue = tenantExtension?.valueReference?.reference
      ?? tenantExtension?.valueString
      ?? tenantExtension?.valueIdentifier?.value
      ?? null;
    const tenantFromExtension = this.normalizeOrganizationId(extensionValue);
    if (tenantFromExtension) {
      return tenantFromExtension;
    }

    // Last resort: attempt to read any Organization reference from performer[]
    const performers: any[] = Array.isArray(serviceRequest?.performer)
      ? serviceRequest.performer as any[]
      : serviceRequest?.performer
        ? [serviceRequest.performer]
        : [];
    for (const performer of performers) {
      const ref = performer?.reference ?? performer;
      const performerOrg = this.normalizeOrganizationId(ref, true);
      if (performerOrg) {
        return performerOrg;
      }
    }

    return null;
  }

  private isOrganizationTenantSystem(system: string | null | undefined): boolean {
    const normalized = (system ?? '').toString().trim().toLowerCase();
    if (!normalized) {
      return false;
    }
    return normalized === this.organizationTenantTagSystem.toLowerCase() || normalized.endsWith('/codesystem/organizationtenant');
  }

  private isOrganizationTenantExtension(url: string | null | undefined): boolean {
    const normalized = (url ?? '').toString().trim().toLowerCase();
    if (!normalized) {
      return false;
    }
    return normalized === this.organizationTenantExtensionUrl.toLowerCase() || normalized.endsWith('/structuredefinition/organizationtenant');
  }

  private isLegacyOrganizationExtension(url: string | null | undefined): boolean {
    const normalized = (url ?? '').toString().trim().toLowerCase();
    if (!normalized) {
      return false;
    }
    return normalized === this.legacyHospitalExtensionUrl.toLowerCase() || normalized === this.actorOrganizationExtensionUrl.toLowerCase();
  }

  private normalizeOrganizationId(raw: unknown, requireOrganizationKeyword = false): string | null {
    const value = (raw ?? '').toString().trim();
    if (!value) {
      return null;
    }

    const sanitized = value.split(/[?#]/)[0];
    const lower = sanitized.toLowerCase();
    const marker = 'organization/';
    const idx = lower.lastIndexOf(marker);
    if (idx >= 0) {
      const remainder = sanitized.substring(idx + marker.length).split('/')[0];
      return remainder || null;
    }

    if (requireOrganizationKeyword) {
      return null;
    }

    return sanitized || null;
  }
  // backendEndPoint = inject(backendEndPointToken);
  private printSingleLabRequest(row: ServiceRequest): void {
    const srId = (row?.id ?? '').toString().trim();
    if (!srId) {
      this.errorService.openandCloseError('Cannot print this lab request because it has no id yet.');
      return;
    }

    const queryParts = [
      `_id=${encodeURIComponent(srId)}`,
      '_format=json',
      '_include=ServiceRequest:subject',
      '_include=ServiceRequest:requester',
      '_include=ServiceRequest:performer',
      '_revinclude=Observation:based-on'
    ];

    const url = `${this.backendEndPoint}/ServiceRequest?${queryParts.join('&')}`;

    this.http.get<Bundle>(url).pipe(take(1),
      switchMap((bundle) => {
        const requesterOrgId = this.getOrganizationTenantId(row);
        // get requeser's  -> pract. Organizqaion and add i o the enry
        if (requesterOrgId) {
          const url = `${this.backendEndPoint}/Organization/${requesterOrgId}?_format=json`;

          return this.http.get<Organization>(url).pipe(
            take(1),
            map((org) => {
              if (org) {
                //manually add the org to the bundle as an entry so that it gets processed and included in the resource map 
                const orgEntry: BundleEntry = {
                  resource: org,
                  fullUrl: `Organization/${org.id}`
                };
                bundle.entry = bundle.entry || [];
                bundle.entry.push(orgEntry);
              } else {
                console.warn('Requester organization not found for id:', requesterOrgId);
              }
              return bundle;
            }

            ),
            catchError((e) => {
              return of(bundle)
            }))
        } else {
          return of(bundle);
        }
      })


    ).subscribe({
      next: (bundle) => {
        const resourceMap = this.buildResourceMap(bundle?.entry);
        const latestRequest = (resourceMap.get(`ServiceRequest / ${srId} `) as ServiceRequest) || row;
        const patient = this.findResourceByReference<Patient>(resourceMap, latestRequest.subject?.reference) ?? null;
        const requester = this.findResourceByReference<Resource>(resourceMap, latestRequest.requester?.reference) ?? null;
        const performerReference = Array.isArray(latestRequest.performer) && latestRequest.performer.length
          ? latestRequest.performer[0]?.reference
          : (latestRequest.performer as any)?.reference;
        const performer = this.findResourceByReference<Resource>(resourceMap, performerReference) ?? null;
        const organization = this.resolveOrganizationResource(resourceMap) || this.cachedOrganization;
        if (organization) {
          this.cachedOrganization = organization;
        }

        const printable: ServiceRequest & { [key: string]: any } = {
          ...latestRequest,
          patientHospitalId: this.extractHospitalIdentifier(patient),
          requesterSignature: this.extractPractitionerSignature(requester as Practitioner),
          patientResource: patient,
          requesterResource: requester,
          performerResource: performer,
          organizationResource: organization
        };
        console.log('Prepared printable lab request with included resources:', printable);
// $#$        // /* debugger; */
        this.requestPrint.printServiceRequest(printable, { title: 'Lab Request' });
      },
      error: (err) => {
        console.error('Failed to fetch included resources for lab request print', err);
        this.errorService.openandCloseError('Unable to load the latest lab request details required for printing.');
      }
    });
  }

  private buildResourceMap(entries?: BundleEntry[]): Map<string, Resource> {
    const map = new Map<string, Resource>();
    (entries || []).forEach((entry) => {
      const resource = entry.resource as Resource | undefined;
      const id = (resource as any)?.id;
      if (resource?.resourceType && id) {
        map.set(`${resource.resourceType}/${id}`, resource);
      }
    });
    return map;
  }

  private findResourceByReference<T extends Resource>(map: Map<string, Resource>, reference?: string | null): T | undefined {
    const ref = (reference || '').toString().trim();
    if (!ref) {
      return undefined;
    }

    if (map.has(ref)) {
      return map.get(ref) as T;
    }

    for (const [key, resource] of map.entries()) {
      if (referenceMatches(ref, key)) {
        return resource as T;
      }
    }

    return undefined;
  }

  private resolveOrganizationResource(map: Map<string, Resource>): Organization | null {
    for (const resource of map.values()) {
      if (resource?.resourceType === 'Organization') {
        return resource as Organization;
      }
    }
    return null;
  }

  private extractHospitalIdentifier(patient: Patient | null): string | null {
    if (!patient?.identifier?.length) {
      return null;
    }

    const expectedSystem = this.getHospitalIdentifierSystem();
    const matcher = patient.identifier.find((identifier) => {
      const coding = identifier?.type?.coding || [];
      return coding.some((code) => {
        const codeMatches = (code?.code || '').toLowerCase() === 'patient-hos-id';
        if (!expectedSystem) {
          return codeMatches;
        }
        return codeMatches && (code?.system || '').toLowerCase() === expectedSystem.toLowerCase();
      });
    });

    return matcher?.value ?? null;
  }

  private extractPractitionerSignature(practitioner: Practitioner | null): string | null {
    if (!practitioner?.extension?.length) {
      return null;
    }

    const signatureExtension = practitioner.extension.find((ext: any) =>
      (ext?.url || '').toLowerCase().includes('signature')
    );

    if (!signatureExtension) {
      return null;
    }

    return (
      signatureExtension.valueString ||
      signatureExtension.valueBase64Binary ||
      signatureExtension.valueAttachment?.data ||
      null
    );
  }

  private getHospitalIdentifierSystem(): string {
    const base = (this.backendEndPoint || '').toString().replace(/\/+$/, '');
    return `${base}/CodeSystem/identifier-type`;
  }
  authService = inject(AuthService);
  fhirTransformService = inject(FhirResourceTransformService);
  fhirResourceService = inject(FhirResourceService)
  private launchSpecimenDialog(row: ServiceRequest) {
    if (!row?.id) {
      this.errorService.openandCloseError('Missing Service Request id.');
      return;
    }

    this.dialog.open(SpecimenSelectionComponent, {
      width: '900px',
      maxHeight: '90vh',
      data: {
        title: 'Specimens for this request',
        serviceRequestIds: [row.id],
        forSelection: false
      }
    });
  }
  private launchResultDialog(row: ServiceRequest) {
    const patientId = this.extractPatientId(row) ?? this.patientId;
    this.addLabResults(patientId || null, row);
  }

  private extractPatientId(row: ServiceRequest): string | undefined {
    const ref = (row?.subject?.reference || '').toString().trim();
    if (!ref) return undefined;
    const parts = ref.split('/').filter(Boolean);
    const id = parts[parts.length - 1] || '';
    return id || undefined;
  }

  // async transformLabRequestWithBilling(row: any): Promise<any> {
  //   const base = row as ServiceRequest;
  //   if (!base?.subject?.reference || !base?.id) {
  //     return base;
  //   }
  //   try {
  //     const patientId = base.subject.reference.split("/")[1];
  //     const cIAndInv = await firstValueFrom(this.sRServ.getChargeItemAndInvoice(patientId, base.id));
  //     const transformed: any = { ...base, relatedChargeItems: cIAndInv.chargeItems, relatedInvoices: cIAndInv.invoices };
  //     return transformed;
  //   } catch (error) {
  //     console.warn('Failed to fetch billing data for lab request:', base.id, error);
  //     return base;
  //   }
  // }

  private pushFilteredLabRequests() {
    const filtered = this.applyLabRequestFilters(this.rawLabRequests);
    this.tableDataLevel2.next(filtered);
  }

  private applyLabRequestFilters(items: any[]): any[] {
    if (!this.appliedLabRequestFilters.length) return items;
    return items.filter((item) =>
      this.appliedLabRequestFilters.every((filter) => {
        const value = this.getNestedFieldValue(item, filter.field);
// $#$        // /* alert(value); */
// $#$        // /* alert(filter.value); */
        if (!filter.values?.length) return true;
        return filter.values.includes(value);
      })
    );
  }

  private getNestedFieldValue(obj: any, path: string): any {
    return path.split('.').reduce((curr, segment) => (curr ? curr[segment] : undefined), obj);
  }

  private readonly backendEndPoint = inject(backendEndPointToken);
  private readonly infoDialog = inject(InfoDialogService);

  private launchViewResultsDialog(row: ServiceRequest) {
    const serviceRequestId = (row?.id ?? '').toString().trim();
    if (!serviceRequestId) {
      this.infoDialog.info('This lab request has no ID yet, so results cannot be linked.', 4500);
      return;
    }

    const patientId = this.extractPatientId(row) ?? this.patientId ?? '';
    if (!patientId) {
      this.infoDialog.info('Cannot open lab results because the patient context is missing.', 4500);
      return;
    }

    this.dialog.open(RequiredObservationResultsTableComponent, {
      maxWidth: '900px',
      maxHeight: '90vh',
      autoFocus: false,
      data: {
        serviceRequest: row,
        patientId,
        forViewingOnly: true,
        enforcePaymentForFinal: false,
        paymentBalanced: true
      }
    });
  }

  private buildLabResultsSetView(serviceRequest: ServiceRequest, observations: Observation[]): {
    resourceData: Record<string, any>;
    detailsBuilderObject: DetailsBuilderObject;
  } {
    const srCodeLabel =
      (serviceRequest as any)?.code?.text ||
      (serviceRequest as any)?.code?.coding?.[0]?.display ||
      (serviceRequest as any)?.code?.coding?.[0]?.code ||
      (serviceRequest as any)?.id ||
      'Lab Request';

    const flat = this.flattenObservationsForDetails(observations);

    const resourceData: Record<string, any> = {
      resourceType: 'LabResultsSet',
      serviceRequestId: serviceRequest?.id ?? 'N/A',
      serviceRequestCode: srCodeLabel,
      serviceRequestStatus: (serviceRequest as any)?.status ?? 'N/A',
      authoredOn: (serviceRequest as any)?.authoredOn ?? 'N/A',
      subject: (serviceRequest as any)?.subject ?? null,
      resultsCount: observations.length,
      ...flat
    };

    const detailsBuilderObject: DetailsBuilderObject = {
      resourceName: 'Lab Results',
      resourceIcon: 'biotech',
      specialHeader: {
        strongSectionKey: 'serviceRequestCode',
        iconSectionKeys: ['serviceRequestStatus'],
        contentSectionKeys: ['subject', 'authoredOn']
      },
      groups: [
        {
          groupName: 'Request',
          groupIcon: 'description',
          groupKeys: ['serviceRequestId', 'serviceRequestStatus', 'authoredOn', 'subject']
        },
        {
          groupName: 'Summary',
          groupIcon: 'info',
          groupKeys: ['resultsCount']
        },
        {
          groupName: 'Results',
          groupIcon: 'science',
          groupKeys: Object.keys(flat)
        }
      ]
    };

    return { resourceData, detailsBuilderObject };
  }

  private flattenObservationsForDetails(observations: Observation[]): Record<string, any> {
    const out: Record<string, any> = {};

    const safe = (v: any) => (v === undefined || v === null ? '' : String(v).trim());

    const obsLabel = (obs: any) =>
      safe(obs?.code?.text) ||
      safe(obs?.code?.coding?.[0]?.display) ||
      safe(obs?.code?.coding?.[0]?.code) ||
      safe(obs?.id) ||
      'Observation';

    const valueLabel = (obs: any) => {
      const vq = obs?.valueQuantity;
      if (vq?.value !== undefined && vq?.value !== null) {
        const unit = vq?.unit || vq?.code || '';
        return `${safe(vq.value)}${unit ? ` ${safe(unit)}` : ''}`.trim();
      }
      const vs = safe(obs?.valueString);
      if (vs) return vs;
      const vcc = obs?.valueCodeableConcept;
      const vccText = safe(vcc?.text) || safe(vcc?.coding?.[0]?.display) || safe(vcc?.coding?.[0]?.code);
      if (vccText) return vccText;
      // If it's a panel, component[] usually carries values
      const comp = Array.isArray(obs?.component) ? obs.component : [];
      if (comp.length) return `${comp.length} component result(s)`;
      return '';
    };

    const specimenLabel = (obs: any) => safe(obs?.specimen?.display) || safe(obs?.specimen?.reference);

    observations.forEach((obs: any, i) => {
      const n = i + 1;
      const label = obsLabel(obs);
      const value = valueLabel(obs);
      const status = safe(obs?.status);
      const effective = safe(obs?.effectiveDateTime || obs?.issued);
      const performer = safe(obs?.performer?.[0]?.display) || safe(obs?.performer?.[0]?.reference);
      const specimen = specimenLabel(obs);

      out[`Result ${n} - Test`] = label;
      if (value) out[`Result ${n} - Value`] = value;
      if (status) out[`Result ${n} - Status`] = status;
      if (effective) out[`Result ${n} - Effective`] = effective;
      if (specimen) out[`Result ${n} - Specimen`] = specimen;
      if (performer) out[`Result ${n} - Performer`] = performer;
    });

    return out;
  }

  private buildObservationDetailsBuilder(observation: Observation): DetailsBuilderObject {
    return {
      resourceName: 'Lab Result',
      resourceIcon: 'visibility',
      specialHeader: {
        strongSectionKey: 'code',
        iconSectionKeys: ['status'],
        contentSectionKeys: ['subject', 'effectiveDateTime']
      },
      groups: [
        { groupName: 'Classification', groupIcon: 'category', groupKeys: ['status', 'category', 'code'] },
        { groupName: 'Value', groupIcon: 'show_chart', groupKeys: ['valueQuantity', 'valueString', 'valueCodeableConcept'] },
        { groupName: 'Related Data', groupIcon: 'history_edu', groupKeys: ['issued', 'performer', 'note'] }
      ]
    };
  }
  private applyAllFilters(): void {
    let filtered = [...this.rawLabRequests];

    // Apply form control filters (status, priority)
    filtered = this.applyFormControlFilters(filtered);

    // Apply external filters (from @Input)
    filtered = this.applyExternalFilters(filtered);

    // Apply search
    filtered = this.applySearch(filtered);

    // Update requisition grouping with filtered data
    this.groupByRequisition(filtered);

    // Flatten and update table
    this.updateTableData();
  }



  private applyExternalFilters(items: ServiceRequest[]): ServiceRequest[] {
    if (!this.appliedExternalFilters.length) {
      return items;
    }

    return items.filter((item: any) => {
      return this.appliedExternalFilters.every((filter) => {
        const value = this.getNestedFieldValue(item, filter.field);
        if (!filter.values?.length) return true;
        return filter.values.includes(value);
      });
    });
  }

  private applySearch(items: ServiceRequest[]): ServiceRequest[] {
    const searchTerm = (this.searchControl.value ?? '').toString().trim().toLowerCase();
    if (!searchTerm) {
      return items;
    }

    return items.filter((item: any) => {
      // Search in multiple fields
      const searchableFields = [
        item.id,
        item.code?.text,
        item.code?.coding?.[0]?.display,
        item.code?.coding?.[0]?.code,
        item.status,
        item.priority,
        item.requisition?.value,
        item.subject?.display,
        item.subject?.reference
      ];

      return searchableFields.some((field) => {
        if (!field) return false;
        return field.toString().toLowerCase().includes(searchTerm);
      });
    });
  }

  private normalizeValue(value: any): string {
    if (value === null || value === undefined) return '';
    return value.toString().trim().toLowerCase();
  }

  private updateTableData(): void {
    // Flatten grouped data for table display
    const flatData: ServiceRequest[] = [];
    Object.values(this.sortedWithRequisition).forEach((group) => {
      flatData.push(...group);
    });

    this.tableDataLevel2.next(flatData);
  }
  private groupByRequisition(requests: ServiceRequest[]): void {
    const sorted: { [key: string]: ServiceRequest[] } = {};

    requests.forEach((request) => {
      const requisitionValue = (request as any).requisition?.value;
      if (requisitionValue) {
        if (!sorted[requisitionValue]) {
          sorted[requisitionValue] = [];
        }
        sorted[requisitionValue].push(request);
      } else {
        if (!sorted['N/A']) {
          sorted['N/A'] = [];
        }
        sorted['N/A'].push(request);
      }
    });

    this.sortedWithRequisition = sorted;
    this.sortedWithRequisitionKeys = Object.keys(sorted);
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  /**
   * Compute permissions for a given resource type.
   * Updates canAdd and canExport observables based on user role.
   * @param resource - The resource type (e.g., 'specimen', 'labRequest', 'location')
   */
  private computePermissions(resource: keyof typeof capacityObject): void {
    this.canAddRequests$ = this.auth.user.pipe(
      map(() => this.auth.can(resource, 'add'))
    );
    this.canExportRequests$ = this.auth.user.pipe(
      map(() => this.auth.can(resource, 'viewAll'))
    );
  }
}
